import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { TanStackRouterDevtools } from "@tanstack/router-devtools";

/**
 * DevTools component that renders React Query and TanStack Router devtools
 * Only renders in development environment
 */
export const DevTools = () => {
  if (process.env.NODE_ENV !== "development") {
    return null;
  }

  return (
    <>
      <TanStackRouterDevtools />
      <ReactQueryDevtools />
    </>
  );
};
